import { animationTransition } from '@shared/utils/animationTransition';
import { StyleSystemProps, styled, Flex } from '@withjoy/joykit';

export const StyledItemWrapper = styled(Flex)``;
export const StyledSkeletonFilterItemContainer = styled(Flex)``;

const checkboxRootStyles: StyleSystemProps = {
  borderRadius: '21px',
  display: 'flex',
  width: '100%',
  paddingY: 4,
  paddingRight: 7,
  paddingLeft: 7,
  transition: animationTransition('background-color'),

  _hover: {
    backgroundColor: 'mono2',
  },
  _active: {
    backgroundColor: 'mono3',
  },
};

const checkboxControlStyles: StyleSystemProps = {
  color: 'mono3',
  borderColor: 'transparent',
  backgroundColor: 'mono3',
  _groupActive: {
    color: 'black',
    backgroundColor: 'mono2',
    borderColor: 'transparent',
    _checked: {
      color: 'black',
    },
  },
  _checked: {
    color: 'strokeHover',
    backgroundColor: 'mono3',
    borderColor: 'transparent',
  },
};

const filterItemContainerStyles: StyleSystemProps = {
  flexDirection: 'row',
  paddingLeft: 7,
  paddingY: 5,
};

export const styles = {
  checkboxRootStyles,
  checkboxControl: checkboxControlStyles,
  filterItemContainer: filterItemContainerStyles,
};
